import type { CategorySection, ProductCard } from '@ria-client/supergraph/roundup/types';

export const createOfferOrderMap = (offers: ProductCard[]): Map<string, number> => {
  const offerOrderMap = new Map<string, number>();
  offers.forEach((offer, index) => {
    offerOrderMap.set(offer.marketplaceEntity.id, index);
  });
  return offerOrderMap;
};

export const filterProductCardsByOffers = (
  productCards: ProductCard[],
  offers: ProductCard[],
): ProductCard[] =>
  productCards.filter(card =>
    offers.some(offer => offer.marketplaceEntity.id === card.marketplaceEntity.id),
  );

export const sortProductCardsByOfferOrder = (
  productCards: ProductCard[],
  offerOrderMap: Map<string, number>,
): ProductCard[] =>
  productCards.slice().sort((a, b) => {
    const orderA = offerOrderMap.get(a.marketplaceEntity.id) ?? Infinity;
    const orderB = offerOrderMap.get(b.marketplaceEntity.id) ?? Infinity;
    return orderA - orderB;
  });

export const sortSectionsByFirstCardOrder = (
  sections: CategorySection[],
  offerOrderMap: Map<string, number>,
): CategorySection[] =>
  sections.sort((a, b) => {
    const firstCardOrderA = offerOrderMap.get(a.productCards[0].marketplaceEntity.id) ?? Infinity;
    const firstCardOrderB = offerOrderMap.get(b.productCards[0].marketplaceEntity.id) ?? Infinity;
    return firstCardOrderA - firstCardOrderB;
  });

export const getBadgeText = (
  sectionEyebrowText?: string,
  sectionTitle?: string,
): string | undefined => {
  if (sectionEyebrowText && sectionTitle) {
    return `${sectionEyebrowText} ${sectionTitle}`;
  }
};
